import { SelectItemModel } from '@shared/models/ComponentsModels/SelectItemModel';
import { ServerErrorsModel } from '@shared/models/Common/ServerErrorsModel';
import { FileContentModel } from '@shared/models/Common';

export interface Enumme { [s: string]: unknown }

export const enumToList: (enumme: Enumme) => string[] = (enumme) => Object
  .entries(enumme)
  .filter(([key]) => !Number.isNaN(Number(key)))
  .map(([, label]): string => label as string);

export const enumToSuggestions: (enumme: Enumme) => SelectItemModel[] = (enumme) => Object
  .entries(enumme)
  .filter(([key]) => !Number.isNaN(Number(key)))
  .map(([value, text]): SelectItemModel => ({ text: text as string, value: +value }));

export const parseErrors: (errors: ServerErrorsModel) => string[] =
  (errors) => Object.values(errors).flat();

const reformatParamsObject = (params: any, prevKey: string | number = ''): [string, any][] =>
  Object.entries(params).reduce((acc: any, [key, val]: any): any => {
    const getKey = () => {
      if (prevKey) {
        const k = (params.length && typeof params.length === 'number') ? `[${key}]` : `.${key}`;
        return `${prevKey}${k}`;
      }
      return key;
    };

    if (val && typeof val === 'object') {
      return [
        ...acc,
        ...reformatParamsObject(val, getKey())
      ];
    }

    return [...acc, [getKey(), encodeURIComponent(val)]];
  }, []);

export const formQueryString = (params: any) =>
  reformatParamsObject(params)
    .map((entries: any) => entries.join('='))
    .join('&');

export const fileContentToFile = async (fileContent: FileContentModel) => {
  const fileBlob = await fetch(
    fileContent.file as string
  ).then((x: Response) => x.blob());
  const file = new File([fileBlob], fileContent.name, {
    type: fileBlob.type,
  });
  return file;
};

export const secToMin = (value: number) => Math.floor(value / 60);

export const formattingDate = (date: string) => {
  if (!date) return null;

  const [year, month, day] = date.split('-');
  return `${month}/${day}/${year}`;
};
